import { addEvent } from '../_util/eventScrollbar';
import { addResizeListener, removeResizeListener } from '../_util/resizeEventScrollbar';
import scrollbarWidth from '../_util/scrollbarWidth';
import Bar from './Bar';

export default {
  name: 'AScrollbar',
  components: { Bar },

  props: {
    native: Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: 'div',
    },
  },

  data() {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      moveX: 0,
      moveY: 0,
      gutter: scrollbarWidth(),
      gutterStyle: {
        marginRight: `-${scrollbarWidth()}px`,
      },
    };
  },
  computed: {
    wrap() {
      return this.$refs.wrap;
    },
  },

  mounted() {
    if (this.native) return;
    this.$nextTick(this.update);
    !this.noresize && addResizeListener(this.$refs.resize, this.update);
    addEvent(this.$refs.wrap, 'scroll', this.handleScroll);
  },

  beforeDestroy() {
    if (this.native) return;
    !this.noresize && removeResizeListener(this.$refs.resize, this.update);
  },
  methods: {
    handleScroll() {
      const wrap = this.wrap;
      this.moveY = (wrap.scrollTop * 100) / wrap.clientHeight;
      this.moveX = (wrap.scrollLeft * 100) / wrap.clientWidth;
      this.$nextTick(() => {
        this.$emit('scroll', { moveX: wrap.scrollLeft, moveY: wrap.scrollTop });
      });
    },

    update() {
      let heightPercentage, widthPercentage;
      const wrap = this.wrap;
      if (!wrap) return;

      heightPercentage = (wrap.clientHeight * 100) / wrap.scrollHeight;
      widthPercentage = (wrap.clientWidth * 100) / wrap.scrollWidth;

      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
    },

    scrollTo(x, y) {
      this.$refs.wrap.scrollTo(x, y);
    },
  },
  render() {
    const { viewStyle, gutterStyle } = this;
    return (
      <div class="ant-scrollbar">
        {this.native ? (
          <div ref="wrap" class={[this.wrapClass, 'ant-scrollbar__wrap']} style={this.gutterStyle}>
            <div
              class={['ant-scrollbar__view', this.viewClass]}
              style={{ ...viewStyle }}
              ref="resize"
            >
              {this.$slots.default}
            </div>
          </div>
        ) : (
          <div
            ref="wrap"
            style={{ ...gutterStyle }}
            class={[
              this.wrapClass,
              'ant-scrollbar__wrap',
              this.gutter ? '' : 'ant-scrollbar__wrap--hidden-default',
            ]}
          >
            <div
              class={['ant-scrollbar__view', this.viewClass]}
              style={{ ...viewStyle }}
              ref="resize"
            >
              {this.$slots.default}
            </div>
            <Bar move={this.moveX} size={this.sizeWidth}></Bar>
            <Bar vertical move={this.moveY} size={this.sizeHeight}></Bar>
          </div>
        )}
      </div>
    );
  },
};
